import React from "react";
import Button from 'react-bootstrap/Button';
import cloneDeep from 'lodash/cloneDeep';

const incrementItemCount = (filterObj, val) => {
    if (!Object.keys(filterObj).includes(val)) {
        filterObj[val] = 1;
    } else {
        filterObj[val] = filterObj[val] + 1;
    }
}

const sortDataViaKey = (key, sortToggle, filteredData) => {
    const sortedData = [].concat(filteredData).sort((a,b) => {
        if (sortToggle) {
            if (a[key] < b[key]) return -1;
            if (a[key] > b[key]) return 1;
        } else {
            if (a[key] < b[key]) return 1;
            if (a[key] > b[key]) return -1;
        }            
        return 0;
    })
    return sortedData;
}

const getBulkData = (filteredData, shownData, bulkCounter, bulkSize, isNewBulk) => {
    let bulk = [];
    let counter = bulkCounter;
    if (!isNewBulk) {
        bulk = bulk.concat(shownData);
    } else {
        counter = 0;
    }
    bulk = bulk.concat(filteredData.slice(bulkSize * counter, bulkSize * (counter + 1)));

    return bulk;
}

const onFilterSelect = (e, filterName, type, selectedFilters, selectedOption) => {
    e.defaultPrevented = true;
    let selectedFilter = e.currentTarget?.id || selectedOption;
    let selectedFiltersObject = cloneDeep(selectedFilters);

    if (!selectedFiltersObject[type]) {
        selectedFiltersObject[type] = {};
    }

    if (!Object.keys(selectedFiltersObject[type]).includes(filterName)) {
        selectedFiltersObject[type][filterName] = [selectedFilter];
    } else if (!selectedFiltersObject[type][filterName].includes(selectedFilter)){
        selectedFiltersObject[type][filterName].push(selectedFilter);
    } else if (selectedFiltersObject[type][filterName].includes(selectedFilter)) {
        selectedFiltersObject[type][filterName] = selectedFiltersObject[type][filterName].filter((value, index) => { 
            return value != selectedFilter;
        });
        if (selectedFiltersObject[type][filterName].length == 0) {
            delete selectedFiltersObject[type][filterName];
        }
    }
    return selectedFiltersObject;
}

const onChipRemove = (filterKey, chip, selectedFilters) => {
    let newSelectedFilters = {...selectedFilters};

    newSelectedFilters.dropdown[filterKey] = newSelectedFilters.dropdown[filterKey].filter((value, index) => { 
        return value != chip;
    });
    if (newSelectedFilters.dropdown[filterKey].length == 0) {
        delete newSelectedFilters.dropdown[filterKey];
    }
    return newSelectedFilters;
}

const loadMoreHandler = (shownData, filteredData, getBulkDataHandler, itemType='reviews', gtmEventRegion='') => {
    if (shownData && filteredData.length > shownData.length) {
        const gtmDataAttributes = gtmEventRegion ? {
            'data-gtm-event-region': gtmEventRegion,
            'data-gtm-event-element': 'load-more-reviews'} : {}

        return (
            <Button variant="secondary" onClick={() => getBulkDataHandler(filteredData)} className={'btn-block'} {...gtmDataAttributes}>
                Load more {itemType}
            </Button>
        )
    }
}

export {
    incrementItemCount,
    sortDataViaKey,
    getBulkData,
    onFilterSelect,
    onChipRemove,
    loadMoreHandler,
}